import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

export interface RecurringInstance {
  id: string;
  occurrence_date: string;
  position: number;
  status: "active" | "cancelled" | "archived";
}

export interface RecurringSeriesInfo {
  series_id: string;
  status: "active" | "paused";
  recurrence_rule: {
    freq: string;
    dtstart?: string;
    until?: string;
    dates?: string[];
  };
  reminder_days_before: number | null;
  instances: RecurringInstance[];
}

/**
 * Recurring series overlay for a poll (null when the poll is not recurring).
 * Public RPC — anonymous voters need it to hide cancelled occurrences and
 * focus the next one.
 */
export function useRecurringSeries(pollId: string | undefined) {
  return useQuery<RecurringSeriesInfo | null>({
    queryKey: ["recurring-series", pollId],
    enabled: !!pollId,
    staleTime: 60 * 1000,
    retry: false,
    queryFn: async () => {
      const { data, error } = await supabase.rpc(
        "get_recurring_series_for_poll",
        { p_poll_id: pollId },
      );
      // Résilience : RPC absente (migration pas encore appliquée) ou erreur
      // réseau → le sondage se comporte comme non récurrent, pas de crash ni
      // de retry en boucle.
      if (error) return null;
      return (data as RecurringSeriesInfo | null) ?? null;
    },
  });
}
